import React from 'react';
export default function  Slider()  {

  return (

        <div className='row'>
                <div  className="col con-img1" >      
                        <img src="./assets/png/s1.png" alt="Logo" className="slide"/>
                </div>

                <div className="col con-img2">        
                        <img src="./assets/png/s2.png" alt="Logo" className="slide"/>
                </div>

                <div  className="col con-img1">        
                        <img src="./assets/png/s3.png" alt="Logo" className="slide"/>
                </div>

                <div className="col con-img2">        
                        <img src="./assets/png/s4.png" alt="Logo" className="slide"/>
                </div>

                <div  className="col con-img1">        
                        <img src="./assets/png/s5.png" alt="Logo" className="slide"/>
                </div>
</div>
  );
};